import { usersApi } from '../api/usersApi'

export const getUsers = async () => {
  try {
    const {
      data: { users },
    } = await usersApi.getUsers()
    return users
  } catch (error) {
    console.error(`Error fetching users: `, error)
    throw error
  }
}
